import React from "react";
import Alert from "@visa/vds/alert";
import AlertIcon from "@visa/vds/alert-icon";
import AlertLabel from "@visa/vds/alert-label";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Icon from "@visa/vds/icon";

const MCSAlertError = (props) => {
  return (
    props.errorMessage !== "" &&
    props.showAlert && (
      <Alert
        id="alert-default-error"
        show={props.showAlert}
        position="relative"
        alertType="error"
        autoCloseTimeout={5000}
        autoClose={true}
        onBeforeClose={() => {
          props.toggleShowErrorAlert(false);
          props.setErrorMessage("");
        }}
        style={{ marginTop: 65 }}
      >
        <Grid>
          <Row>
            <Col>
              <AlertIcon>
                <Icon name="error" resolution="low" />
              </AlertIcon>
              <AlertLabel>{props.errorMessage}</AlertLabel>
            </Col>
          </Row>
        </Grid>
      </Alert>
    )
  );
};

export default MCSAlertError;
